export default __webpack_public_path__ + "static/top-efb11a022c65d504119087985677def0.jpg";